// modules
import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import OptionChain from 'modules/OptionChain';
// ui library
import TableCell from '@upstox/upstox-ui/component/base/TableCell';
import { View } from '@upstox/upstox-ui';
// store
import { useStore } from 'modules/Stores';
// utils
import { getSpotPrice } from 'modules/OptionChain/utils';
// constants
import { DATA_SETTINGS } from 'modules/OptionChain/consts';
// styles
import * as css from './styles';

const SpotCell: React.FC = () => {
  const {
    loading,
    spotScripData,
    activeTokens,
    updateActiveStrikesIfNeeded,
    strikes,
    strikesAmountToShow,
    handleLoadMoreData,
    selectedExpiry,
    calculateMaxOi,
    calculateMaxTotalVolume,
    tableSettings: {
      dataSettings: { noOfStrikes },
    },
  } = useStore('OptionChainStore');

  const {
    getOIValueByInstrumentKeys,
    getTotalVolumeValueByInstrumentKeys,
  } = useStore('LiveDataStore');
  const { getByInstrumentKey } = useStore('LiveDataStore');
  const activeTokensOIValue = getOIValueByInstrumentKeys(activeTokens) || [];
  const activeTokensTotalVolumeValue =
    getTotalVolumeValueByInstrumentKeys(activeTokens) || [];

  const liveData = getByInstrumentKey(spotScripData?.instrumentKey || '');

  const spotPrice = useMemo(() =>
    getSpotPrice(liveData?.lastTradedPrice, liveData?.close),
    [liveData],
  );

  // recalculate MaxOI when any live data for active strikes changes
  useEffect(() => {
    calculateMaxOi(activeTokensOIValue);
  }, [activeTokensOIValue, calculateMaxOi]);

  // recalculate Max Total Volume when any live data for active strikes changes
  useEffect(() => {
    calculateMaxTotalVolume(activeTokensTotalVolumeValue);
  }, [activeTokensTotalVolumeValue, calculateMaxTotalVolume]);

  // To generate activeStrikesWithSpot which in turn generate callTableData and putTableData
  // To update active strikes in case of change of strikes, number of strikes to be shown, selectedExpiry
  useEffect(() => {
    // do not update active strikes if spot price is null
    if (spotPrice === null) return;
    updateActiveStrikesIfNeeded(
      strikes,
      Number(spotPrice),
      strikesAmountToShow,
    );
    OptionChain.updateStrikesWithSpot(Number(spotPrice));
  }, [
    spotPrice,
    strikes,
    strikesAmountToShow,
    updateActiveStrikesIfNeeded,
    selectedExpiry,
  ]);

  useEffect(() => {
    if (noOfStrikes === DATA_SETTINGS.showAll) {
      handleLoadMoreData(60);
    } else {
      handleLoadMoreData(20);
    }
  }, [noOfStrikes, handleLoadMoreData]);

  return (
    <TableCell align="center" css={css.spotCell}>
      <View css={css.spotPriceContainer}>
        <View css={css.spotPrice}>{loading ? '--' : spotPrice || '--'}</View>
      </View>
    </TableCell>
  );
};

export default observer(SpotCell);
